import NewListContainer from "./NewList";
export default NewListContainer;
